import { Injectable } from '@angular/core';
import { first, map, Observable, switchMap, tap } from 'rxjs';
import { QualificationOutcome } from 'src/app/core/enums/lead/qualification-outcome.enum';
import { QualificationStatus } from 'src/app/core/enums/lead/qualification-status.enum';
import { ColumnSorting } from 'src/app/core/models/common/column-sorting.model';
import { LeadSummary } from 'src/app/core/models/lead/lead-summary.model';
import { Lead } from 'src/app/core/models/lead/lead.model';
import { LeadProxyService } from 'src/app/infrastructure/lobby-proxy/lobby-proxy-lead/lead-proxy.service';
import { mapLeadDtoToLead } from 'src/app/shared/mappings/lead-model-dto/lead-dto.mapping';
import { leadSummaryDtoToLeadSummary } from 'src/app/shared/mappings/lead-model-dto/lead-summary-dto.mapping';
import { throwIfLobbyErrorCode, throwIfLobbyStatusErrorCode } from 'src/app/shared/utils/pipes/throwIfLobbyErrorCode.pipe';
import { AgentQualificationOutcomes } from '../models/agent-qualification-outcome.type';
import { Store } from '@ngrx/store';
import { LeadActions } from 'src/app/core/events/lead.actions';

@Injectable({
  providedIn: 'root'
})
export class AgentService {

  constructor(
    private readonly appStore: Store,
    private readonly leadProxyService: LeadProxyService) { }

  getUserOffers$(): Observable<LeadSummary[]> {
    return this.leadProxyService.searchLeadMine$(0, 100, ['Offer'],
      undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined,
      'Updated-', 'Summary').pipe(
        first(),
        throwIfLobbyErrorCode,
        map(dto => dto.data.map(lead => leadSummaryDtoToLeadSummary(lead)))
      )
  }

  getUserAssignations$(pageIndex: number = 0,
    leadId: number | null = null,
    leadQualificationStatus: QualificationStatus[] | null = [],
    leadQualificationOutcome: QualificationOutcome[] | null = [],
    sort: ColumnSorting | null = null): Observable<LeadSummary[]> {

    return this.leadProxyService.searchLeadMine$(pageIndex, 50, ['Assignation'],
      10, undefined, undefined, undefined, leadId, undefined, leadQualificationStatus, leadQualificationOutcome, undefined,
      this.getSortingKey(sort), 'Summary').pipe(
        first(),
        throwIfLobbyErrorCode,
        map(dto => dto.data.map(lead => leadSummaryDtoToLeadSummary(lead)))
      )

  }

  getLeadInfo$(id: number | string): Observable<Lead> {
    return this.leadProxyService.getLeadById$(id).pipe(
      first(),
      throwIfLobbyErrorCode,
      map(dto => dto.data),
      mapLeadDtoToLead
    )
  }

  qualifyLead$(leadId: number | string, outcome: AgentQualificationOutcomes) {

    console.log('qualify', outcome)

    if ([QualificationOutcome.Unfitting, QualificationOutcome.Spam].includes(outcome))

      return this.leadProxyService.rejectLead$(leadId, outcome as QualificationOutcome.Unfitting | QualificationOutcome.Spam).pipe(
        first(),
        throwIfLobbyStatusErrorCode,
        tap(() => this.appStore.dispatch(LeadActions.leadRejected(leadId)))
      )

    else return this.leadProxyService.qualifyLead$(leadId, outcome as QualificationOutcome.Interested | QualificationOutcome.NeverReplied | QualificationOutcome.NonInterested).pipe(
      first(),
      throwIfLobbyStatusErrorCode,
      tap(() => this.appStore.dispatch(LeadActions.leadQualified(leadId)))
    )
  }

  acceptLeadOffer$(leadId: number | string) {
    return this.leadProxyService.acceptLeadOffer$(leadId).pipe(
      first(),
      throwIfLobbyStatusErrorCode,
      tap(() => this.appStore.dispatch(LeadActions.leadOfferAccepted(leadId)))
    )
  }

  refuseLeadOffer$(leadId: number | string) {
    return this.leadProxyService.refuseLeadOffer$(leadId).pipe(
      first(),
      throwIfLobbyStatusErrorCode,
      tap(() => this.appStore.dispatch(LeadActions.leadOfferRefused(leadId)))
    )
  }

  private getSortingKey(sort: ColumnSorting | null): 'LeadId' | 'ProcessingStatus' | 'QualificationStatus' | 'QualificationOutcome' | 'Created' | 'Updated' | 'LeadId-' | 'ProcessingStatus-' | 'QualificationStatus-' | 'QualificationOutcome-' | 'Created-' | 'Updated-' | null {
    if (!sort) return null

    switch ([sort.columnName, sort.sortingDirection].join(',')) {
      case 'id,up': return 'LeadId';
      case 'updated,up': return 'Updated';
      case 'outcome,up': return 'QualificationOutcome';

      case 'id,down': return 'LeadId-';
      case 'updated,down': return 'Updated-';
      case 'outcome,down': return 'QualificationOutcome-';

      default: return null
    }
  }

}
